import { Component, Input, OnInit } from '@angular/core';
import { DialerTestService, TestResultCallStats } from 'dialer';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { DriveTestPoint, DriveTestPointSeq, PathTestPoint, PathTestPointSeq } from '../../../core/models';
import { DriveTestDoc } from '../../../core/schema/drive-test-schema';
import { PathTestDoc } from '../../../core/schema/path-test-schema';
import { DriveTestSeqService, PointTestLogService } from '../../../core/services';
import { TestSeqService } from '../../../core/services/test-seq.service';
import { DialerClientTestSeqModalComponent } from '../../../dialer-client/dialer-client-testseq/dialer-client-testseq-modal/dialer-client-testseq-modal.component';

export type TestSeqInfo = {
  seqid: string
  status: string
  endTime: string
  dialerStatus: string
  stats: TestResultCallStats
}
@Component({
  selector: 'app-path-test-point-seq-status',
  templateUrl: './path-test-point-seq-status.component.html'
})
export class PathTestPointSeqStatusComponent {

  timer: NodeJS.Timeout;
  duration: number;
  testSeqInfo$: Observable<TestSeqInfo>
  //tz: string

  @Input() pathTestDoc: PathTestDoc | DriveTestDoc
  @Input('seq') set inputSeq(seq: PathTestPointSeq | DriveTestPointSeq) {
    this.seq = seq
    const { startTime, stopTime } = seq || {}
    clearInterval(this.timer)
    if(startTime && !stopTime) {
      var start = new Date(startTime)
      this.timer = setInterval(() => {
        var end = new Date()
        this.duration = end.getTime() - start.getTime()
      }, 1000);
    } else {
      this.duration = new Date(stopTime).getTime() - new Date(startTime).getTime()
    }
    if ( this.seq?.dialerSeqId ) {
      if(this.pathTestDoc.type == "path test") {
        this.testSeqInfo$ =
        this._testSeqService.rxCollection.findOne(this.seq.dialerSeqId).$.pipe(
          map(doc=> doc ? {
            seqid: doc.seqid,
            status: doc.status,
            endTime: doc.endTime,
            dialerStatus: doc.dialer?.status,
            stats: this.dialerTestService.computeCallStats(doc.dialer)
          } : null)
        )
      } else if(this.pathTestDoc.type == "drive test"){
        this.testSeqInfo$ =
        this._driveTestSeqService.rxCollection.findOne(this.seq.dialerSeqId).$.pipe(
          map(doc=> doc ? {
            seqid: doc.seqid,
            status: doc.status,
            endTime: doc.endTime,
            dialerStatus: doc.dialer?.status,
            stats: this.dialerTestService.computeCallStats(doc.dialer)
          } : null)
        )
      }

    } else {
      this.testSeqInfo$ = null
    }
  }

  @Input('testPoint') set inputTestPoint(pt: PathTestPoint | DriveTestPoint) {
    this.testPoint = pt
  }

  public testPoint: PathTestPoint | DriveTestPoint
  public seq: PathTestPointSeq | DriveTestPointSeq

  errorMsg$ : Observable<string>
  componentErrorMsg$ = new Subject<string>()
  currentUserId: string

  constructor(
    private modalService: BsModalService,
    public pointTestLogService: PointTestLogService,
    public _testSeqService: TestSeqService,
    public _driveTestSeqService: DriveTestSeqService,
    public dialerTestService: DialerTestService
    ) {
      //this.tz = new Date().toLocaleTimeString('en-us',{timeZoneName:'short'}).split(' ')[2]
  }


  testResultsModalRef: BsModalRef

  showDialerSeqId(seq: PathTestPointSeq | DriveTestPointSeq, testSeqInfo: TestSeqInfo ){
    const initialState = {
      seqContext: {seq, type: this.pathTestDoc.type}
    }
    DialerClientTestSeqModalComponent.showModal(this.modalService, initialState)
  }

}
